import estilos from '../DetalleDeCompraComponent.module.css'
import React, { useState, Fragment } from 'react'
import moment from 'moment'
import { useSelector, useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { actualizarInformacionCompraHologramas } from '../../../../../redux/DuckPanelHologramas/ModuloComprasDuck'
import { agregarInventario, actualizarInventario } from '../../../../../redux/DuckPanelHologramas/ModuloInventarioDuck'

const HologramaAdminComponent = (props) => {

    const detalleCompra = props.detalleCompra
    const dispatch = useDispatch()

    const [prefijo, setPrefijo] = React.useState('')
    const [folioinicial, setFolioInicial] = React.useState('')
    const [foliofinal, setFolioFinal] = React.useState('')
    var fechaHoy = moment().format('YYYY-MM-DD');

    const [openModal, setOpenModal] = React.useState(false)
    const [titleModal, setTitleModal] = React.useState('')
    const [bodyModal, setBodyModal] = React.useState('')
    const [botonModal, setBotonModal] = React.useState('')
    const [deshabilitarBoton, setDeshabilitarBoton] = React.useState(false)
    const cancelarModal = () => setOpenModal(false)

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        p: 4,
    };

    const guardarCambios = async () => {

        var totalHologramas = Number(Number(detalleCompra.cantidadmezcal) + Number(detalleCompra.cantidadbebidasmezcal))
        var sugerencia = Number(Number(folioinicial) + totalHologramas - 1)

        if (prefijo == '' || folioinicial == '' || foliofinal == '') {
            setTitleModal("¡Tenemos un problema!")
            setBodyModal("La compra no se puede realizar si existe un campo vacío. Asegurate de llenar todos los campos requeridos.")
            setBotonModal("Aceptar")
            setOpenModal(true)
        } else if (Number(foliofinal) != sugerencia) {
            setTitleModal("Existe un error con el folio final.")
            setBodyModal("El folio final no es válido. Ingresa un folio que coincida con el total de hologramas solicitados.")
            setBotonModal("Aceptar")
            setOpenModal(true)
        } else {
            setTitleModal("Confirmación de compra.")
            setBodyModal("¿Estás seguro que deseas realizar la compra? No se podrán realizar cambios después.")
            setBotonModal("Continuar")
            setOpenModal(true)
        }
    }

    const closeModal = async () => {
        if (botonModal == "Continuar") {
            setOpenModal(false)
            setDeshabilitarBoton(true)
            let fechaSolicitud = new Date(fechaHoy).toISOString()
            if (detalleCompra?.login?.cliente?.[0]?.inventarioclientehologramas.length == 0) {
                let numeroMezcal = detalleCompra?.cantidadmezcal?.toString()
                let numeroBebidas = detalleCompra?.cantidadbebidasmezcal?.toString()
                let dataInventario = {
                    hologramasmezcal: numeroMezcal, hologramasbebidas: numeroBebidas, idcliente: detalleCompra?.login?.cliente?.[0]?.idcliente
                }
                await dispatch(agregarInventario(dataInventario))
            } else {
                let hologramasmezcal = 0
                if (detalleCompra?.login?.cliente?.[0]?.inventarioclientehologramas?.[0].hologramasmezcal == '') hologramasmezcal = 0
                else hologramasmezcal = Number(detalleCompra?.login?.cliente?.[0]?.inventarioclientehologramas?.[0].hologramasmezcal)

                let hologramasbebidas = 0
                if (detalleCompra?.login?.cliente?.[0]?.inventarioclientehologramas?.[0].hologramasbebidas == '') hologramasbebidas = 0
                else hologramasbebidas = Number(detalleCompra?.login?.cliente?.[0]?.inventarioclientehologramas?.[0].hologramasbebidas)

                let numeroMezcal = Number(Number(detalleCompra?.cantidadmezcal) + Number(hologramasmezcal))?.toString()
                let numeroBebidas = Number(Number(detalleCompra?.cantidadbebidasmezcal) + Number(hologramasbebidas)).toString()

                let dataInventario = {
                    hologramasmezcal: numeroMezcal, hologramasbebidas: numeroBebidas, idcliente: detalleCompra?.login?.cliente?.[0]?.idcliente,
                    idinventario: detalleCompra?.login?.cliente?.[0]?.inventarioclientehologramas?.[0].idinventario
                }
                await dispatch(actualizarInventario(dataInventario))
            }
            const data = {
                idcomprahologramas: detalleCompra?.solicitudescomprashologramas?.[0]?.idcomprahologramas,
                idfc40_solicitudadquisicionholo: detalleCompra?.solicitudescomprashologramas?.[0]?.idfc40_solicitudadquisicionholo,
                fecha: fechaSolicitud,
                prefijo: prefijo, folioinicial: folioinicial, foliofinal: foliofinal,
                //hologramasmezcal: numeroMezcal, hologramasbebidas: numeroBebidas, idcliente: detalleCompra?.login?.cliente?.[0]?.idcliente
            }
            await dispatch(actualizarInformacionCompraHologramas(data))

            props.history.push('/PanelComprasComponent')
        } else
            setOpenModal(false)
    }

    const cancelarCambios = () => {
        props.history.push('/PanelComprasComponent')
    }

    return (
        <div className={`${estilos.contenedor} row mt-3`} >
            <div className='col-md-4'>
                <div className="form-floating mb-2">
                    <select className={`form-select`}
                        value={prefijo} onChange={e => setPrefijo(e.target.value)}
                        disabled={detalleCompra.solicitudescomprashologramas?.length == 0}>
                        <option value="">Seleccione un prefijo</option>
                        <option value={`A`} >{`A`}</option>
                        <option value={`B`} >{`B`}</option>
                    </select>
                    <label htmlFor='floatingInput'>Prefijo</label>
                </div>
            </div>
            <div className='col-md-4'>
                <div className="form-floating mb-2">
                    <input type="number" min="0" className={`form-control `} id="floatingInput" value={folioinicial} onChange={e => setFolioInicial(e.target.value)} onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                        disabled={detalleCompra.solicitudescomprashologramas?.length == 0} />
                    <label htmlFor='floatingInput'>Folio inicial</label>
                </div>
            </div>
            <div className='col-md-4'>
                <div className="form-floating mb-2">
                    <input type="number" min="0" className={`form-control `} id="floatingInput" value={foliofinal} onChange={e => { setFolioFinal(e.target.value) }} onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                        disabled={detalleCompra.solicitudescomprashologramas?.length == 0} />
                    <label htmlFor='floatingInput'>Folio final</label>
                </div>
            </div>
            {detalleCompra.solicitudescomprashologramas?.length > 0 &&
                <Fragment>
                    <div className='col-md-6 mt-3'>
                        <button onClick={() => guardarCambios()} className='btn btn-outline-success' disabled={deshabilitarBoton}>Aplicar la compra</button>
                    </div>
                    <div className='col-md-6 mt-3'>
                        <button onClick={() => cancelarCambios()} className='btn btn-outline-danger'>Cancelar la compra</button>
                    </div>
                </Fragment>
            }
            <Modal
                open={openModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        <center><strong>{titleModal}</strong></center>
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <center>{bodyModal}</center>
                    </Typography>
                    <Typography sx={{ mt: 5 }}>
                        <button className={`btn ${estilos.botonModal}`} onClick={closeModal}> {botonModal} </button>
                    </Typography>
                    {
                        botonModal == "Continuar" &&
                        <Typography sx={{ mt: 2 }}>
                            <button className={`btn ${estilos.botonCancelarModal}`} onClick={cancelarModal}> Cancelar </button>
                        </Typography>

                    }
                </Box>
            </Modal>
        </div>
    );

};

export default withRouter(HologramaAdminComponent)






